import React, { useState } from 'react';
import Button from '../common/Button';
import Input from '../common/Input';
import Toggle from '../common/Toggle';

const TransactionForm = ({ onTransaction, loading }) => {
  const [formData, setFormData] = useState({
    amount: '',
    description: '',
    type: 'CREDIT',
  });
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));

    // Clear error when user starts typing
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: '' }));
    }
  };

  const handleTypeChange = (type) => {
    setFormData((prev) => ({ ...prev, type }));
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.amount || isNaN(parseFloat(formData.amount))) {
      newErrors.amount = 'Amount is required and must be a valid number';
    }

    if (parseFloat(formData.amount) === 0) {
      newErrors.amount = 'Amount cannot be zero';
    }

    if (!formData.description.trim()) {
      newErrors.description = 'Description is required';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    const transactionData = {
      amount:
        formData.type === 'DEBIT'
          ? -Math.abs(parseFloat(formData.amount))
          : Math.abs(parseFloat(formData.amount)),
      description: formData.description.trim(),
    };

    onTransaction(transactionData);

    // Reset form after successful transaction
    setFormData({
      amount: '',
      description: '',
      type: 'CREDIT',
    });
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Input
          label="Amount"
          name="amount"
          type="number"
          step="0.0001"
          min="0.0001"
          value={formData.amount}
          onChange={handleChange}
          placeholder="0.0000"
          required
          error={errors.amount}
        />

        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Transaction Type <span className="text-red-500 ml-1">*</span>
          </label>
          <Toggle
            options={[
              { label: 'CREDIT', value: 'CREDIT' },
              { label: 'DEBIT', value: 'DEBIT' },
            ]}
            value={formData.type}
            onChange={handleTypeChange}
          />
        </div>
      </div>

      <Input
        label="Description"
        name="description"
        type="text"
        value={formData.description}
        onChange={handleChange}
        placeholder="Enter transaction description"
        required
        error={errors.description}
      />

      <Button
        type="submit"
        variant={formData.type === 'CREDIT' ? 'success' : 'danger'}
        loading={loading}
        className="w-full"
      >
        {formData.type === 'CREDIT' ? 'Credit Amount' : 'Debit Amount'}
      </Button>
    </form>
  );
};

export default TransactionForm;
